import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../../../infrastructure/config';
import { RequestHelper } from '../../../infrastructure/core/requestHelper';
import { Rating } from '../../../models/DTO/ratings/rating';
import { createRatingRequestModel } from '../../../models/requestModels/ratings/createRatingRequestModel';

@Injectable({
  providedIn: 'root'
})
export class RatingsService {

  private ratingURL: string = Config.api + 'product/';

  constructor(private httpClient: HttpClient) { }

  getRatingsPerProduct(itemId: string) {
    let params = itemId + "/reviews";
    return this.httpClient.get<Rating>(this.ratingURL + params);
  }

  createRatingPerProduct(itemId: string, rating: createRatingRequestModel) {
    let params = itemId + "/reviews";
    return this.httpClient.post<Rating>(this.ratingURL + params, rating);
  }
}
